import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CenQtyMinState from "@tCentro/Store/Reducer/CenQtyMinState";
import { Draft } from "immer";

const initialState: CenQtyMinState = {
    isMinError: false,
};

const reducer = {
    "Pages/CenQtyMinState": (
        draft: Draft<CenQtyMinState>,
        action: {
            isMinError: boolean;
        },
    ) => {
        draft.isMinError = action.isMinError;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
